var exports = {
  "a": "x127c5a35--ff20a2--shield",
};

module.exports = exports;
